import DistributionListList from './DistributionListList';
import DistributionListCreate from './DistributionListCreate';
import DistributionListIcon from '@material-ui/icons/Subject';
import DistributionListShow from './DistributionListShow';

export default {
  list: DistributionListList,
  create: DistributionListCreate,
  show: DistributionListShow,
  icon: DistributionListIcon
};
